// 业务单据类型配置
export default {
  interOrderType: {
    collapseTitle: {
      title: '计息单据类型',
    },
    table: {
      interestOrderCode: '计息单据代码',
      interestOrderCodePlaceholder: '请输入计息单据代码',
      interestOrderName: '计息单据名称',
      interestOrderNamePlaceholder: '请输入计息单据名称',
      interestOrderDesc: '计息单据描述',
      interestOrderDescPlaceholder: '请输入计息单据描述',
      configImplClass: '配置文件类',
      configImplClassPlaceholder: '请输入配置文件类',
      implClass: '实现类',
      implClassPlaceholder: '请输入实现类',
    },
    btnList: {
      save: '保存',
    },
    msg: {
      noData: '您还未选择任何数据',
      deleteSuccess: '删除成功',
      cancelled: '已取消',
      saveSussess: '保存成功！',
      saveFail: '保存失败！',
    },
  },
};
